/**
 * A class which contains the information for the fields
 * which can be used to order products on.
 * @author Nick Groenewegen
 */
export class SortField {
  public optionKey: string;

  constructor(
    public key: string,
    public name: string,
    public asc: boolean,
    public showOrder: boolean
  ) {
    this.optionKey = this.key + '|' + (this.asc ? 'ASC' : 'DESC');
  }

  get sortIconHtml(): string {
    if (!this.showOrder) {
      return null;
    }

    return this.asc ? '&uarr;' : '&darr;';
  }
}
